import DeviceSettings from "./DeviceSettings";
import VolumeAnalyser from "../Controllers/AudioAnalyser/VolumeAnalyser";
import { SCENE_INTERACTION } from "../../constants/scene";

const getCustomLogo = (customLogo) => (customLogo && customLogo !== './textures/empty.png' ? customLogo : null);

const deviceSettingAloneTemplate = (customLogo) => `
<div class="modal device-setting-modal" id="welcomeCheckModal">
    <div class="modal-background"></div>
    ${getCustomLogo(customLogo) ? `<div class="modal-background-logo"><img alt="Avatar" src="${getCustomLogo(customLogo)}" /></div>` : ''}
    <div class="modal-content">
        <button class="device-setting-modal__close-btn">
            <span class="material-icons md-26 clickable close-modal">close</span>
        </button>

        <div class="device-setting-modal__header">
            ${getCustomLogo(customLogo) ? `<div class="device-setting-modal__header__logo"><img alt="" src="${getCustomLogo(customLogo)}" /></div>` : ''}
            <h1 class="device-setting-modal__location" data-lang="">
                Location name
            </h1>
        </div>

        <div class="device-setting-modal__content device-setting-modal__content--step-2">
            <div class="device-setting-modal__media-wrapper">
                <div class="device-setting-modal__media">
                    <div class="device-setting-avatar-holder">
                        <div>
                            <img class="device-setting-avatar-image" alt="" src="/textures/icons/icon_video_off.svg" />
                            <div class="confirm-body welcome-error-text" data-lang="request-permission-you-must-text">
                                Erlaubnis erteilen</div>
                        </div>
                        <video autoplay muted class="device-setting-webcam"></video>
                    </div>
                    <div class="device-setting-modal__media__audio">
                        <div class="device-setting-micTest">
                            <div class="speaking-indicator">
                                <span></span><span></span><span></span>
                            </div>
                        </div>
                    </div>
                    <h1 class="device-setting-modal__location" data-lang="">
                        Location name
                    </h1>
                </div>
            </div>
            
            <div class="device-setting-modal__devices">
                <div class="device-setting-modal__devices__device input-field__input mb-3">
                    <div class="profile-form-group" style="">
                        <label for="userName" class="label-icon-username">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.79997 8C9.79997 6.67452 10.8745 5.6 12.2 5.6C13.5254 5.6 14.6 6.67452 14.6 8C14.6 9.32548 13.5254 10.4 12.2 10.4C10.8745 10.4 9.79997 9.32548 9.79997 8ZM12.2 4C9.99083 4 8.19997 5.79086 8.19997 8C8.19997 10.2091 9.99083 12 12.2 12C14.4091 12 16.2 10.2091 16.2 8C16.2 5.79086 14.4091 4 12.2 4ZM9 13.6001C7.93913 13.6001 6.92172 14.0215 6.17157 14.7716C5.42143 15.5218 5 16.5392 5 17.6001V19.2001C5 19.6419 5.35817 20.0001 5.8 20.0001C6.24183 20.0001 6.6 19.6419 6.6 19.2001V17.6001C6.6 16.9635 6.85286 16.3531 7.30294 15.903C7.75303 15.4529 8.36348 15.2001 9 15.2001H15.4C16.0365 15.2001 16.647 15.4529 17.0971 15.903C17.5471 16.3531 17.8 16.9635 17.8 17.6001V19.2001C17.8 19.6419 18.1582 20.0001 18.6 20.0001C19.0418 20.0001 19.4 19.6419 19.4 19.2001V17.6001C19.4 16.5392 18.9786 15.5218 18.2284 14.7716C17.4783 14.0215 16.4609 13.6001 15.4 13.6001H9Z" fill="currentColor"></path>
                            </svg>
                        </label>
                        <input name="userName" id="device-setting-userName" class="profile-form-input" type="text" placeholder="Username">
                    </div>
                </div>
                <div class="device-setting-modal__devices__device input-field__input mb-3">
                    <label for="device-setting-speakerSelect" class="input-field__input__prefix">
                        <img alt="Speaker" src="/textures/icons/icon_sound.svg">
                    </label>
                    <select id="device-setting-speakerSelect" class="device-setting-select">
                        <option>Speaker</option>
                    </select>
                    <label for="device-setting-speakerSelect" class="input-field__input__suffix">
                        <img alt="Arrown down" src="/textures/icons/icon_arrow_down.svg">
                    </label>
                </div>

                <div class="device-setting-modal__devices__device input-field__input mb-3">
                    <label for="device-setting-micSelect" class="input-field__input__prefix">
                        <img alt="Microphone" src="/textures/icons/icon_mic_on.svg">
                    </label>
                    <select id="device-setting-micSelect" class="device-setting-select">
                        <option>Microphone</option>
                    </select>
                    <label for="device-setting-micSelect" class="input-field__input__suffix">
                        <img alt="Arrown down" src="/textures/icons/icon_arrow_down.svg">
                    </label>
                </div>

                <div class="device-setting-modal__devices__device input-field__input mb-3">
                    <label for="device-setting-camSelect" class="input-field__input__prefix">
                        <img alt="Camera" src="/textures/icons/icon_video_on.svg">
                    </label>
                    <select id="device-setting-camSelect" class="device-setting-select">
                        <option>Camera</option>
                    </select>
                    <label for="device-setting-camSelect" class="input-field__input__suffix">
                        <img alt="Arrown down" src="/textures/icons/icon_arrow_down.svg">
                    </label>
                </div>

                <div class="device-setting-mirror-cam">
                    <label data-lang="invert-camera-text">Mirror Cam</label>
                    <input id='deviceSettingInvertCamera' type="checkbox" class="input-field__switch_input">
                </div>
            </div>
            
            <div class="device-setting-modal__buttons">
                <button class="device-setting-modal__buttons__close-btn">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>
`

export default class DeviceSettingsAlone extends DeviceSettings {
    constructor({ model, socket }) {
        super({ model, socket, initOnConstruct: false });

        this.template = $(deviceSettingAloneTemplate(this.model.sceneData.customLogo));

        this.$element = {
            selectMic: this.template.find('#device-setting-micSelect'),
            testMic: this.template.find('.device-setting-micTest'),
            speakingIndicator: this.template.find('.speaking-indicator'),

            selectSpeaker: this.template.find('#device-setting-speakerSelect'),
            testSpeaker: null,

            selectCamera: this.template.find('#device-setting-camSelect'),
            testCamera: this.template.find("video"),
            invertCamera: this.template.find("#deviceSettingInvertCamera"),

            closeBtn: this.template.find('.device-setting-modal__close-btn, .device-setting-modal__buttons__close-btn'),
        }

        this.userName = this.template.find("#device-setting-userName");
        this.userName.val(this.model.config.userName);

        this.initStates()
        this.addListeners()
        this.addCustomListeners()

        this.setSelectedDropdownsToSystemDevices()
    }

    initStates() {
        this.template.find('.device-setting-modal__location').text(this.model.sceneData.name)
    }

    addCustomListeners() {
        this.$element.closeBtn.on('click', () => {
            this.template.removeClass('is-active')
            this.onClose();
        })
    }

    onClose() {
        super.onClose();
        const user = this.model.socket.getUsersObject()[this.model.config.userId];
        const newValue = this.userName.val();
        if (user && (newValue !== user?.userName)) {
            user.userName = newValue;
            if (this.model.config.isGuest) {
                $("#guest-avatar-name").val(newValue);
            }
            const userId = this.model.config.userId;
            const userName = newValue;
            let data = {};
            data = {
                userId,
                userName,
            };
            this.model.saveProfile({ url: this.model.config.saveProfileUrl, data }, () => {
                this.model.info('success', $trans('user-profile-text-saved'));
            });

            this.model.dispatchEvent({ type: SCENE_INTERACTION.USER_AVATAR_CHANGED, data });
        }

        if (this.volumeAnalyser) {
            this.model.removeAudioAnalyzer(this.volumeAnalyser)
            this.volumeAnalyser.destroy()
            this.volumeAnalyser = null
        }
        this.model.hideLoading();
    }
    onOpen() {
        const user = this.model.socket.getUsersObject()[this.model.config.userId];
        this.userName.val(user?.userName);
        super.onOpen();
    }

    setMicTestHandler(stream) {
        if (!this.volumeAnalyser) {
            this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
            this.volumeAnalyser = new VolumeAnalyser();
            this.volumeAnalyser.setOnSpeakingChanged((isSpeaking) => {
                this.$element.testMic.toggleClass('speaking-outline', isSpeaking)
                this.$element.speakingIndicator.toggleClass('speaking-indicator--active', isSpeaking)
            })

            this.model.registerAudioAnalyzer(this.volumeAnalyser);
        }

        this.volumeAnalyser
            .setAudioContext(this.audioContext)
            .setStream(stream)
            // width of avatar, width of the indicator
            .setScaleRangeFromPixels(180, 200)
            .setEnabled(true)
    }
}
